/**
 * Representation of the user available roles.
 * @enum {string}
 */
export enum UserRole {
  staff = 'staff',
  user = 'user',
}
